import React, { useState } from 'react';
import { StyledCTALink, StyledCardWrapper, StyledContentWrapper, StyledTextPairing } from './CashFundCard.styles';
import { Flex } from '@components/Flex';
import { getRootUrl } from '@utils/urlHelpers.util';
import { LazyLoadWrapper } from '@components/LazyLoadWrapper';
import { useTranslation } from 'react-i18next';

export const CashFundCard = () => {
  const [isVisible, setIsVisible] = useState(false);
  const { t } = useTranslation('registry');
  const cashFundCard = t('registryCashFundSection.cashFundCard');
  return (
    <StyledCardWrapper isVisible={isVisible} image={cashFundCard.image}>
      <LazyLoadWrapper beforeLoad={() => setIsVisible(true)}>
        <></>
      </LazyLoadWrapper>
      <StyledContentWrapper>
        <StyledTextPairing
          titleVariant="calloutHed40"
          titleColor="white"
          titleTagName="h3"
          title={cashFundCard.title}
          body={cashFundCard.body}
          bodyVariant="dek20"
          bodyColor="white"
          bodyMaxWidth="480px"
          marginBottom={[6, 9]}
          textAlign="center"
        />
        <Flex justifyContent="center" style={{ width: '100%' }}>
          <StyledCTALink
            aria-label={cashFundCard.learnMoreCTA}
            id="honeyMoonRegistryCTA"
            href={getRootUrl(cashFundCard.path)}
            variant="primary"
            typography="featureHed17"
            hasChevron
          >
            {cashFundCard.learnMoreCTA}
          </StyledCTALink>
        </Flex>
      </StyledContentWrapper>
    </StyledCardWrapper>
  );
};
